import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import "./CalculationMainPage.css";
import arrow from "../../../../assets/img/equal-arrow.jpg"
import CustomizationForm from "./ImpedenceCustomization/CustomizationForm";
import ImpedancePreview from "./ImpedencePreview/ImpedancePreview";
import ViewStackUp from "./ImpedencePreview/ViewStackUp";
import ImpedanceValue from "./CustomizationFormFields/ImpedanceValue";

class CalculationMainPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectValue:"1",
            impedanceStatus:null
        };

        this.onSelectChange = this.onSelectChange.bind(this);
    }

    onSelectChange = (event) => {
        this.setState({
            selectValue: event.target.value
        });
    };
    getImpedanceValueStatus= (impedanceStatus) => {
        this.setState({impedanceStatus:impedanceStatus})
    };

    render() {
        return(
            <div className="impedance-calculator-content">
                <div className="impedance-calculator-div">
                        <div className="title-1 text-align-left">
                            <FormattedMessage id="app.impedance-main.title"
                                              defaultMessage="Impedance Calculation"
                                              description=""/>
                        </div>
                        <hr/>
                    <div className="row">
                        <div className="col-md-6 quote-div">
                            <div className="row">
                                <div className="col-md-5">
                                    <select className="form-control" value={this.state.selectValue}
                                            onChange={this.onSelectChange}>
                                        <option value="1">impedance + trace space</option>
                                        <option value="2">trace width + trace space</option>
                                    </select>
                                </div>
                                <div className="col-md-2 col-md-offset-5">
                                    <img src={arrow} className="pull-right"/>
                                </div>
                            </div>
                            <div className="spacer"></div>
                            <div className="row">
                                <CustomizationForm selectValue={this.state.selectValue}
                                                   getImpedanceValueStatus={this.getImpedanceValueStatus}/>
                            </div>

                        </div>
                        <div className="col-md-6 preview-div">
                            <div className="row">
                                <div className="col-md-5">
                                    <button className="btn btn-default btn-md">
                                        {this.state.selectValue=== "1" &&
                                        <text>trace Width</text>
                                        }
                                        {this.state.selectValue=== "2" &&
                                        <text>impedance</text>
                                        }
                                    </button>
                                </div>
                            </div>
                            <div className="spacer"></div>
                            <div className="row">
                                {this.state.impedanceStatus!== null &&
                                    <div>
                                        <ViewStackUp/>
                                        <br/>
                                        <ImpedancePreview/>
                                    </div>

                                }
                                {this.state.impedanceStatus=== null &&
                                <div className="impedance-empty-customize-div "></div>

                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CalculationMainPage;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/CalculationMainPage.js